<template lang="pug">
  section.Search

    .HomeSearchResults_noresult(v-if="Number(totalResults) === 0")
      h2 {{ noResultMessages ? noResultMessages[Math.floor(Math.random() * noResultMessages.length)] : $t('search.noresult') }}

    .HomeSearchResults_list(:style="isLoading ? 'opacity: .2;' : ''")
      HomeSearchResultsList(:items="results" ref="list" v-if="searchListType")
      HomeSearchResultsMap(:items="resultsMap" @coordsFilter="coordsFilter" :totalResults="totalResults" v-else)

      // SwitcherIcon(:active="listType" @toggle="toggleListType")

    InfiniteScrollLoader(v-show="isLoading")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SampleModel from '@/models/SampleModel'
import { Component } from 'vue-instantsearch'

import SearchSide from '@/components/SearchSide'
import HomeSearchResultsList from '@/components/HomeSearchResultsList'
import HomeSearchResultsMap from '@/components/HomeSearchResultsMap'
import SwitcherIcon from '@/components/common/SwitcherIcon'
import InfiniteScrollLoader from '@/components/common/InfiniteScrollLoader'
import BackgroundRelief from "@/components/common/BackgroundRelief.vue";
import ScrollTop from "@/components/common/ScrollTop.vue";

export default {
  mixins: [Component],
  name: 'recherche',
  components: {
    ScrollTop,
    BackgroundRelief,
    SearchSide,
    HomeSearchResultsList,
    HomeSearchResultsMap,
    SwitcherIcon,
    InfiniteScrollLoader
  },
  data () {
    return {
      noResultMessages: null,
      stackedResults: [],
      isNewQuery: false,
      stackedRefinements: [],
      page: 1,
      isLoading: false
    }
  },
  watch: {
    searchListType () {
      if (this.searchListType) {
        this.searchStore.stop()
        this.searchStore.clearRefinements('lat')
        this.searchStore.clearRefinements('lng')
        this.searchStore.start()
        this.searchStore.refresh()
      }
    },
    query() {
      this.isNewQuery = true
      this.page = 1
    },
    activeRefinements() {
      if (JSON.stringify(this.searchStore.activeRefinements) !== JSON.stringify(this.stackedRefinements)) {
        this.isNewQuery = true
        this.page = 1
      }
      this.stackedRefinements = this.searchStore.activeRefinements
    },
    page () {
      this.updatePage()
    },
    totalResults() {
      this.isNewQuery = true
      this.page = 1
    }
  },
  computed: {
    ...mapGetters(['searchOptions', 'nbItemDisplay', 'searchListType']),
    activeRefinements () {
      return this.searchStore.activeRefinements
    },
    query() {
      return this.searchStore.query
    },
    totalResults() {
      return this.searchStore.totalResults
    },
    results () {
      return this.searchResultsSamples
    },
    resultsMap () {
      let validMapSamples = []

      let uniqLocations = []

      for (const item in this.searchResultsSamples) {
        if (this.searchResultsSamples[item]._data.lat && this.searchResultsSamples[item]._data.lng) {
          const sampleLocation = [this.searchResultsSamples[item]._data.lat, this.searchResultsSamples[item]._data.lng]
          const existing = this.findExisting([...uniqLocations], sampleLocation)
          if (existing.length) {
            this.searchResultsSamples[item]._data.multiple = existing.length
          }
          uniqLocations.push(sampleLocation)
          validMapSamples.push(this.searchResultsSamples[item])
        }
      }

      for (const item in validMapSamples) {
        if (validMapSamples[item]._data.multiple) {
          var angle = validMapSamples[item]._data.multiple + 1
          var x = (1 + angle) * Math.cos(angle)
          var y = (1 + angle) * Math.sin(angle)

          validMapSamples[item]._data.lat = validMapSamples[item]._data.lat + (0.0001 * x)
          validMapSamples[item]._data.lng = validMapSamples[item]._data.lng + (0.00015 * y)
        }
      }

      return validMapSamples
    },
    searchResults () {
      if (
        this.stackedResults.length === 0 ||
        this.searchStore.results.length === 0
      ) {
        this.stackedResults.push(...this.searchStore.results)
      } else {
        if (this.page === this.searchStore.page) { // Avoid bug on several searchStore refresh which redirects to the 1st one
          if (this.isNewQuery) {
            this.stackedResults = [...this.searchStore.results];
            this.isNewQuery = false;
          } else {
            // Detect if some id are already added for avoiding duplicate push (error on lifecycle refresh, it displays the first searchStore results before the new)
            const compareResultsToStacked = this.stackedResults.filter(stackedResult => stackedResult.objectID === this.searchStore.results[0].objectID)
            if (compareResultsToStacked.length === 0) {
              this.stackedResults.push(...this.searchStore.results)
            }
          }
        }
      }
      return this.stackedResults
    },
    searchResultsSamples () {
      let r = this.searchResults
      if (this.searchOptions && this.searchOptions.stratigraphic_age_limits) {
        r = r.filter(
          (r) =>
            r.stratigraphic_age_limits &&
            parseInt(r.stratigraphic_age_limits.from) >=
              this.searchOptions.stratigraphic_age_limits.from &&
            parseInt(r.stratigraphic_age_limits.to) <=
              this.searchOptions.stratigraphic_age_limits.to
        )
      }

      return r.map((r) => new SampleModel(r))
    }
  },
  mounted () {
    this.updateStore(this.results.length)

    setTimeout(() => {
      this.setSearchOpen(true)
    }, 600)

    // Infinite scroll
    if (this.$refs['list'] && this.$refs['list'].$el) {
      this.$refs['list'].$el.addEventListener('scroll', event => {
        const { scrollHeight, scrollTop, clientHeight } = event.target
        if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1 && this.searchStore.totalPages > this.page) {
          this.isLoading = true
          this.page++
          setTimeout(() => {
            this.isLoading = false
          }, 1500)
        }
      })
    }
  },
  beforeDestroy () {
    this.setSearchOpen(false)
    //this.searchStore.stop()
  },
  updated () {
    this.updateStore(this.results.length)
  },
  methods: {
    ...mapActions([
      'setSearchOpen',
      'updateNbItemDisplay'
    ]),

    findExisting (array, value) {
      return array.filter(e => (e[0] === value[0] && e[1] === value[1]))
    },
    updateStore (number) {
    // update le nombre d'item affiché dans le store
      this.updateNbItemDisplay(number)
    },

    toggleListType (state) {
      this.listType = state
    },

    getNoResultMsg () {
      this.$api.getSearchMsg(this.$i18n.locale).then((response) => {
        this.noResultMessages = response.data.messages
      })
    },

    coordsFilter (coords) {
      this.searchStore.stop()

      this.searchStore.clearRefinements('lat')
      this.searchStore.clearRefinements('lng')

      this.searchStore.addNumericRefinement('lat', '>=', coords.sw.lat)
      this.searchStore.addNumericRefinement('lat', '<=', coords.ne.lat)

      this.searchStore.addNumericRefinement('lng', '>=', coords.sw.lng)
      this.searchStore.addNumericRefinement('lng', '<=', coords.ne.lng)

      this.searchStore.start()
      this.searchStore.refresh()
    },

    updatePage () {
      if (typeof this.page === 'number' && this.page > 0) {
        this.searchStore.page = this.page
        this.searchStore.start()
        this.searchStore.refresh()
      }
    },
  }
}
</script>

<style lang="stylus" scoped>

.Search
  position relative
  height 100%
  width 100%
  background #000

  .HomeSearchResults_list
    position absolute
    top 0
    left 0
    padding 0
    margin 0
    overflow auto
    width 65%
    height 100%
    font-size: 0;
    scroll-behavior: smooth;

    @media $mq_s_only
      width 100%
      top 140px
      height calc(100vh  - 140px)

    .SwitcherIcon
      position absolute
      right 20px
      bottom 20px

  .ais-pagination
      position absolute
      bottom 0
      left 0
      width 65%
      display flex
      justify-content center
      color white

.InfiniteScrollLoader
  position absolute
  top 50%
  left 0
  width 65%
  z-index 100
  transform translateY(-50%)

  &_diamond
    background-color #FFEFCE
</style>
